<script>
    import router from "page";
    import { onMount } from "svelte";

    import Select from "../components/Select.svelte";

    import { fetchGet } from "../utils/utilsFetch.js";

    import { isSales, salesCompanyKey } from "../stores.js";

    let users = [];

    let companyKey;

    onMount(async () => {
        if (!$isSales) return;

        users = await fetchGet(`/api/users-select`);
    });
</script>

<Select
    options={users}
    bind:value={$salesCompanyKey}
    emptyOptionName="Klijent"
    settings={{
        valueKey: "companyKey",
        nameKey: "companyKey",
    }}
    style={"width: 150px;"}
    callback={() => {
        // router(`/?salesCompanyKey=${$salesCompanyKey}`);

        // Create a URL object from the current location
        const currentUrl = new URL(window.location.href);

        // Use URLSearchParams to work with the query string
        const searchParams = new URLSearchParams(currentUrl.search);

        // Set the 'salesCompanyKey' parameter to the new value
        searchParams.set("salesCompanyKey", $salesCompanyKey);

        // Replace the current query string with the updated one
        currentUrl.search = searchParams.toString();

        // Update the location with the new URL
        window.location.href = currentUrl.toString();

        // window.location.href = `/?salesCompanyKey=${$salesCompanyKey}`;
    }}
/>
